import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import InviteButton from 'project/components/invite_collaborator_button';
import { toggleCollaboratorModal } from 'project/ducks/collaborators';

export function mapStateToProps() {
  return {};
}

export function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    toggle: toggleCollaboratorModal,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(InviteButton);



// WEBPACK FOOTER //
// ./project/containers/invite_collaborator_button.js